exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".name-for-signin input[data-v-4084878a]{display:inline-block;min-height:auto!important}.name-for-signin[data-v-4084878a]{font-size:1.5rem}", ""]);

